import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import currencyFormatter from 'currency-formatter';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import IconGift from 'yoda-core-components/lib/assets/svg/IconGift.svg';
import List from 'yoda-core-components/lib/components/List/List';
import config from 'yoda-core-components/lib/components/List/List/List.config';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ProductMiniDetails from '../ProductMiniDetails/ProductMiniDetails';
import * as styles from './GiftWrapper.css';

const cx = classNames.bind(styles);

function renderProductList(giftWrap) {
    const getItem = (giftItem) => {
        const item = {
            id: giftItem.product.number,
            name: giftItem.product.name,
            quantity: giftItem.quantity,
            imageURL: giftItem.product.imageURL,
        };
        return item;
    };

    const giftWrapItemRenderer = (giftItem) => (
        <ProductMiniDetails productItem={getItem(giftItem)} />
    );
    return (
        <div
            className={`${cx('productsSection')} ${dt([
                'smMd:-ml-1',
                'lg:-ml-2',
                'border-t',
                'border-solid',
                'border-light-white',
            ])}`}
        >
            <List
                direction={config.direction.VERTICAL}
                spacing={config.spacing.COZY}
                datasource={giftWrap.items}
                childRenderer={giftWrapItemRenderer}
            />
        </div>
    );
}

function GiftWrapper({ giftWrap, index, currency }) {
    return (
        <div
            data-automation-id={`at-gift-box-section-${index}`}
            className={`${cx('giftWrapper')} ${dt([
                'pb-1',
                'sm:border-b-[15px]',
                'sm:border-solid',
                'sm:border-light-white',
            ])}`}
        >
            <div
                className={`${cx('giftWrapperTitle')} ${dt([
                    'pt-4',
                    'sm:pl-4',
                    'smOnly:pl-0',
                    'mdOnly:pl-2',
                ])}`}
            >
                <Icon iconType="svg" width="40px" height="40px" viewBox="0 0 48 48">
                    <IconGift />
                </Icon>
                <span
                    data-automation-id={`at-gift-box-package-${index}`}
                    className={`${cx('heading')} ${dt(['text-black', 'font-open-sans-bold'])}`}
                >
                    Package {index + 1}
                </span>
            </div>
            <div
                className={`${cx('giftWrapperSection')} ${dt([
                    'py-0',
                    'smOnly:px-4',
                    'mdOnly:px-2',
                    'lg:px-6',
                ])}`}
            >
                <div
                    className={`${cx('details')} ${dt([
                        'px-0',
                        'pt-0',
                        'pb-4',
                        'leading-7',
                        'text-black',
                    ])}`}
                >
                    <div data-automation-id={`at-gift-box-receiver-${index}`}>
                        <span
                            className={`${cx('heading')} ${dt([
                                'text-black',
                                'font-open-sans-bold',
                            ])}`}
                        >
                            To:{' '}
                        </span>
                        {giftWrap.personalizedInstructions.to}
                    </div>
                    <div data-automation-id={`at-gift-box-from-${index}`}>
                        <span
                            className={`${cx('heading')} ${dt([
                                'text-black',
                                'font-open-sans-bold',
                            ])}`}
                        >
                            From:{' '}
                        </span>
                        {giftWrap.personalizedInstructions.from}
                    </div>
                </div>
                <div
                    className={`${cx('details')} ${dt([
                        'px-0',
                        'pt-0',
                        'pb-4',
                        'leading-7',
                        'text-black',
                    ])}`}
                >
                    <div>
                        <span
                            className={`${cx('heading')} ${dt([
                                'text-black',
                                'font-open-sans-bold',
                            ])}`}
                        >
                            Message:
                        </span>
                    </div>
                    <div data-automation-id={`at-gift-box-msg-${index}`}>
                        {giftWrap.personalizedInstructions.message}
                    </div>
                </div>
                <div
                    className={`${cx('details')} ${dt([
                        'px-0',
                        'pt-0',
                        'pb-4',
                        'leading-7',
                        'text-black',
                    ])}`}
                >
                    <div>
                        <span
                            className={`${cx('heading')} ${dt([
                                'text-black',
                                'font-open-sans-bold',
                            ])}`}
                        >
                            Gift wrap:
                        </span>
                    </div>
                    <div data-automation-id={`at-gift-box-type-name-${index}`}>
                        {giftWrap.type.name}
                    </div>
                    <div data-automation-id={`at-gift-box-price-${index}`}>
                        ({currencyFormatter.format(giftWrap.type.price, { code: currency })} )
                    </div>
                </div>
                {renderProductList(giftWrap)}
            </div>
        </div>
    );
}

GiftWrapper.defaultProps = {
    index: 1,
    currency: 'USD',
};

GiftWrapper.propTypes = {
    giftWrap: PropTypes.objectOf(PropTypes.string).isRequired,
    index: PropTypes.number,
    currency: PropTypes.string,
};

export default GiftWrapper;
